module.exports = __webpack_public_path__ + "img/39.10.pH.86dec280.png";